import {useEffect, useState} from 'react';
import {managerAPI} from './useManagerData';
import {watchLiveRefresh} from '../../hooks/liveRefresh';
import {positionEditError} from './positionEditValues';

export const usePositionPreview = (id, patch, valid, expectedStatus) => {
  const [state, setState] = useState({data: null, loading: true, error: ''});
  const [revision, setRevision] = useState(0);
  const key = JSON.stringify(patch || {});
  useEffect(() => {
    let disposed = false, controller, sequence = 0;
    setState({data: null, loading: valid, error: '', key});
    if (!valid) return;
    const load = async () => {
      const ticket = ++sequence;
      controller?.abort(); controller = new AbortController();
      setState(current => ({...current, loading: true, error: ''}));
      try {
        const response = await managerAPI.post(`/positions/${id}/edit-preview`, JSON.parse(key), {signal: controller.signal, timeout: 20000});
        if (response.data.after.status !== expectedStatus) throw new Error('Pozisyonun durumu değişti. Pencereyi kapatıp listeyi yenileyin.');
        if (!disposed && ticket === sequence) setState({data: response.data, loading: false, error: '', key});
      } catch (error) {
        if (!disposed && ticket === sequence) setState({data: null, loading: false, error: error.isAxiosError ? positionEditError(error) : error.message, key});
      }
    };
    const timer = setTimeout(load, 300);
    const stop = watchLiveRefresh(load, 10000);
    return () => { disposed = true; clearTimeout(timer); stop(); controller?.abort(); };
  }, [id, key, valid, revision, expectedStatus]);
  // Never allow an old draft's response to enable saving the latest draft.
  const current = state.key === key && valid;
  return {...state, data: current ? state.data : null, loading: valid && (!current || state.loading), refresh: () => setRevision(value => value + 1)};
};